import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { formatDims } from "./formats";

async function renderNode(node, targetW) {
  const scale = targetW / node.offsetWidth;
  return html2canvas(node, {
    backgroundColor: null,
    scale,
    useCORS: true,
    allowTaint: true,
    logging: false,
  });
}

export async function exportSinglePNG(node, filename, format = "1x1") {
  const { w } = formatDims(format);
  const canvas = await renderNode(node, w);
  canvas.toBlob((blob) => { if (blob) saveAs(blob, filename); }, "image/png");
}

export async function exportZIP(nodes, baseName = "carousel", format = "1x1", caption = "") {
  const { w } = formatDims(format);
  const zip = new JSZip();
  for (let i = 0; i < nodes.length; i++) {
    const canvas = await renderNode(nodes[i], w);
    const base64 = canvas.toDataURL("image/png").split(",")[1];
    zip.file(`${baseName}-${String(i + 1).padStart(2, "0")}.png`, base64, { base64: true });
  }
  if (caption && caption.trim()) {
    zip.file("caption.txt", caption);
  }
  const blob = await zip.generateAsync({ type: "blob" });
  saveAs(blob, `${baseName}.zip`);
}

export async function exportPDF(nodes, filename = "carousel.pdf", format = "1x1") {
  const { w, h } = formatDims(format);
  const pdf = new jsPDF({ orientation: h > w ? "portrait" : "landscape", unit: "px", format: [w, h] });
  for (let i = 0; i < nodes.length; i++) {
    const canvas = await renderNode(nodes[i], w);
    const img = canvas.toDataURL("image/png");
    if (i > 0) pdf.addPage([w, h], h > w ? "portrait" : "landscape");
    pdf.addImage(img, "PNG", 0, 0, w, h);
  }
  pdf.save(filename);
}

export function copyText(text) {
  const fallback = () => {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      return true;
    } catch { return false; }
  };
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).catch(() => { fallback(); });
  }
  return Promise.resolve(fallback());
}
